module.exports = __webpack_public_path__ + "static/media/Just_giving_logo.9090b3e7.png";